import deviceReducer from './device.slice'

export default deviceReducer
